<template>
  <div class="th">
    <slot></slot>
    <div>
      <span v-if="item.sign == 0" v-for="(item, index) in data" :key="index">
        {{ item.level }}
      </span>
      <span v-else-if="item.sign == 1">
        <label>
          <input
            type="checkbox"
            class="checkbox"
            @click="similarCheckBox($event)"
          />
          <span>{{ item.level }}</span>
        </label>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CwSimilarTh",
  data() {
    return {
      is_first: '',
      accessToken: '',
      getSimilarThObj: {},
    }
  },
  created() {
    // 保存taoken
    let info = JSON.parse(localStorage.getItem("userInfo"));
    if (info) {
      this.accessToken = info.accessToken;
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    thData: {
      type: Array,
      default: () => [],
    }
  },
  methods: {
    similarCheckBox(event) {
      let that = this;
      if (event.target.checked) {
        that.is_first = Number(event.target.checked);
      } else {
        that.is_first = Number(event.target.checked);
      }
      that.getSimilarThObj = {
        is_first: that.is_first
      }
      that.$emit('getSimilarThObjFun', that.getSimilarThObj)
      // 文章收藏接口
      // that.$http.axiosFun(
      //   that.$api.article_collection.similar_article,
      //   {
      //     is_first: that.is_first,
      //     // page: val,
      //     aid: that.thData.aid,
      //     mid: that.thData.mid,
      //   },
      //   function (res) {
      //     if (res.code == 0) {
      //       console.log(res)
      //       that.getSimilarObj = {
      //         similar_article: res.data.similar_article
      //       }
      //       that.$emit('getSimilarObjFun', that.getSimilarObj)
      //       // that.getSimilarObj.similar_article = res.data.similar_article;
      //     }
      //   },
      //   {
      //     "Content-Type": "application/x-www-form-urlencoded",
      //     accessToken: that.accessToken,
      //   }
      // );
      // console.log(that.istop, that.getSimilarThObj);
    },
  },
};
</script>

<style lang="less">
.th {
  width: 100%;
  // border: solid 1px green;
  // box-sizing: border-box;
  height: 40px;
  background-color: #f1f1f1;
  div {
    display: flex;
    justify-content: space-around;
    span {
      width: calc(100% / 8);
      // border: solid 1px;
      display: inline-block;
      line-height: 40px;
      text-align: center;
      label {
        .checkbox {
          width: 18px;
          height: 18px;
          display: inline-block;
          margin-top: calc(40px / 2 - 22px / 2);
          float: left;
        }
        span {
          width: 40px;
          margin-left: 2px;
          height: 40px;
          display: inline-block;
          line-height: 40px;
          float: left;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cw-similar-th.vue